import { render, staticRenderFns } from "./CatchupTable.vue?vue&type=template&id=ec17fc66"
import script from "./CatchupTable.vue?vue&type=script&lang=js"
export * from "./CatchupTable.vue?vue&type=script&lang=js"
import style0 from "./CatchupTable.vue?vue&type=style&index=0&id=ec17fc66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports